<template>
  <div>
    <template v-if="isMarkdown(message)">
      <div class="msg-markdown-text" v-html="renderMarkdown(message.content)" @click="handleMarkdownClick"></div>
    </template>
    <template v-else>
      <div class="msg-text" v-html="renderHtml(message.content)" @click="handleMarkdownClick"></div>
      <span v-if="message.loading" class="msg-loading"><van-loading size="18px" /></span>
    </template>
  </div>
</template>

<script>
  import markdownit from 'markdown-it'
  const ai_bot_avatar = require('@/assets/ai/ai_greet.png');
  const ai_right = require('@/assets/ai/ai_right.png');
  const md = markdownit({
    html: true, // 允许解析 HTML
  })

  const markHtmlTagReg = /<(h[1-6]|ul|ol|li|a|pre|code|table|blockquote|strong|em|img)>?/

  export default {
    props: {
      message: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      renderHtmlWithVNodeStr(str) {
        const clickableRule = /@\{\{(.+?)\}\}/g;
        let result = '';
        let lastIndex = 0;

        str.replace(clickableRule, (match, text, offset) => {
          // 普通文本
          if (offset > lastIndex) {
            result += str.slice(lastIndex, offset);
          }
          result += `<div class="clickable-text" data-click-text="${text}">
            <div class="ai-icon">
              <img src="${ai_bot_avatar}" alt="icon" />
            </div>
            <div class="clickable-content">
              ${text}
            </div>
            <div class="ai-arrow">
              <img src="${ai_right}" alt="icon" />
            </div>
          </div>`;
          lastIndex = offset + match.length;
        });

        // 剩余文本
        if (lastIndex < str.length) {
          result += str.slice(lastIndex);
        }

        return result;
      },
      handleMarkdownClick(e) {
        const target = e.target
        if (target.classList.contains('clickable-text')) {
          this.$emit('markdown-click', target.dataset.clickText)
        }
      },
      isMarkdown(message = {}) {
        if (message.mark) {
          return true
        }

        try {
          const html = md.render(message.content)
          if (markHtmlTagReg.test(html)) {
            message.mark = true
            return true
          } else {
            return false
          }
        } catch (error) {
          message.mark = false
          return false
        }
      },
      renderHtml(str) {
        return this.renderHtmlWithVNodeStr(str)
      },
      renderMarkdown(str) {
        const replacedStr = this.renderHtmlWithVNodeStr(str)

        md.renderer.rules.table_open = (tokens, idx, options, env, self) => {
          return '<div class="table-scroll-wrapper scrollbar-width-none">' +
            '<div class="table-scroll-container">' + self.renderToken(tokens, idx, options)
        }

        md.renderer.rules.table_close = (tokens, idx, options, env, self) => {
          return self.renderToken(tokens, idx, options) + '</div></div>'
        }

        // md.renderer.rules.image_open = (tokens, idx, options, env, self) => {
        //   return '<div class="markdown-image-wrapper">' + self.renderToken(tokens, idx, options)
        // }

        // md.renderer.rules.image_close = (tokens, idx, options, env, self) => {
        //   return self.renderToken(tokens, idx, options) + '</div>'
        // }

        md.renderer.rules.image = (tokens, idx, options, env, self) => {
          const token = tokens[idx]
          token.attrSet('class', 'markdown-image')

          return '<div class="markdown-image-wrapper">' + self.renderToken(tokens, idx, options, env, self) + '</div>'
        }
        return md.render(replacedStr)
      },
    }
  }
</script>

<style lang="scss" scoped>
  .msg-text {
    font-size: 15px;
    color: rgba(0,0,0,0.65);
    white-space: normal;
    word-break: keep-all;
    overflow-wrap: break-word;
  }
  .msg-loading {
    display: inline-block;
    vertical-align: middle;
  }
  .msg-markdown-text {
    font-size: 15px;
    color: rgba(0,0,0,0.65);
    white-space: normal;
    /deep/ * {
      padding: 0;
      margin: 4px 0;
      box-sizing: border-box;
      word-break: break-all;
      font-size: 15px;
      white-space: normal;
      word-break: keep-all;
      overflow-wrap: break-word;
    }
    /deep/ a {
      &:link, &:visited, &:hover, &:active {
        color: #0000EE
      }
    }
    /deep/ img {
      display: block;
    }
    /deep/ ol, ul {
      list-style: inside;
    }
    /deep/ .table-scroll-wrapper {
      max-width: 100%;
      overflow-x: auto;
      width: fit-content;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      border: 0.5px solid #d8dee4;
      border-top: 0;
      border-radius: 8px;
      margin: 0;
      .table-scroll-container {
        flex: 1 0 auto;
        margin: 0;
        box-sizing: border-box;
      }
      table {
        border-collapse: collapse;
        margin: 0;
        thead tr:first-child {
          background: #f7f7f7;
        }
        tr {
          border-top: 0.5px solid #d8dee4;
          background: #FBFBFB;
        }
        td, th {
          min-width: 100px;
          max-width: 400px;
          border: 0;
          padding: 8px 12px;
        }
      }
    }

    /deep/ .markdown-image-wrapper {
      contain: content;
      position: relative;
      width: 100%;
      max-width: 255px;
      background: #ffffff;
      overflow: hidden;
      aspect-ratio: auto;
      .markdown-image {
        display: block;
        width: 100%;
        height: auto; /* 保证按比例缩放 */
        object-fit: contain; /* 防止裁剪 */
        margin: 0;
      }
    }
  }

  // 自定义可点击文本样式
  /deep/.clickable-text {
    display: flex;
    padding: 6px 8px;
    margin-bottom: 8px;
    padding-right: 14px;
    // width: fit-content;
    box-sizing: border-box;
    background: linear-gradient( 270deg, #737EFF 0%, #9F8DFC 100%);
    box-shadow: 0px 2px 4px 0px rgba(7, 41, 177, 0.05);
    border-radius: calc(25px / 2);
    align-items: center;
    cursor: pointer;
    pointer-events: auto;
    min-height: calc(76px / 2);
    &:hover {
      opacity: 0.9;
    }
    .ai-icon {
      pointer-events: none;
      width: 20px;
      height: 20px;
      background: linear-gradient( 270deg, #73E3FF 0%, #998DFC 100%);
      box-shadow: 0px 2px 4px 0px rgba(7, 41, 177, 0.05);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
      img {
        width: 12px;
      }
    }
    .clickable-content {
      pointer-events: none;
      font-weight: bold;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 21px;
      flex: 1;
      text-align: left;
      min-width: 35vw;
      white-space: normal;
      word-break: keep-all;
      overflow-wrap: break-word;
    }
    .ai-arrow {
      pointer-events: none;
      width: 12px;
      height: 15px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        height: 100%;
        object-fit: contain;
      }
    }
    // 元素末尾
    &:last-child {
      margin-bottom: 0px;
    }
  }
</style>
